import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 获取党建活动列表
export function listPartyActivities(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partyActivity.listPartyActivities',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增党建活动
export function savePartyActivity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partyActivity.savePartyActivity',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新党建活动
export function updatePartyActivity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partyActivity.updatePartyActivity',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取党建活动详情
export function getPartyActivity(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partyActivity.getPartyActivity',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取活动报名记录
export function listPartyActivitySigns(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partyActivitySign.listPartyActivitySigns',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
